import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";

export default function CompanyManagerFormModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors] = useState({});
  const {userid} = useSession();


  const validateForm = () => {
    const company_name = document.getElementById("company_name").value.trim();
    let newErrors = {};
    if (!company_name) {
      newErrors.company_name = "Company name is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before saving.", "danger");
      return;
    }

    const formData = new FormData();
    formData.append("id", userData?.id || "");
    formData.append("company_name", document.getElementById("company_name").value.trim());
    formData.append("sort_name", document.getElementById("sort_name").value.trim());
    formData.append("website", document.getElementById("website").value.trim());
    formData.append("status", document.getElementById("status").value);
    formData.append("Sender", document.getElementById("sender_name").value.trim());
    formData.append("smtp_user", document.getElementById("smtp_user").value.trim());
    formData.append("smtp_password", document.getElementById("smtp_password").value.trim());
    formData.append("smtp_url", document.getElementById("smtp_url").value.trim());
    formData.append("smtp_port", document.getElementById("smtp_port").value.trim());
    formData.append("sms_user", document.getElementById("sms_user").value.trim());
    formData.append("sms_password", document.getElementById("sms_password").value.trim());
    formData.append("sms_uti", document.getElementById("sms_uti").value.trim());
    formData.append("sms_url", document.getElementById("sms_url").value.trim());
    formData.append("support_email", document.getElementById("support_email").value.trim());
    formData.append("support_phone", document.getElementById("support_phone").value.trim());
    formData.append("userid", {userid});
    formData.append("action", "ADDUpdate");
    const logoFile = document.getElementById("logo").files[0];
    if (logoFile) formData.append("logo", logoFile);

    try {
      const response = await fetch("https://api.mokshiq.in/company_action", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });

      if (!response.ok) {
        showMainToast("Something went wrong!", "danger");
        return;
      }

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Success!", "success");
        onClose();
         if (onSuccess) onSuccess();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit Company" : "Add Company"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: mode === "edit" ? "Update" : "Save", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="form-validation">
          {/* Company Name */}
          <div className="col-md-6">
            <label className="form-label">Company Name</label>
            <input
              className={`form-control ${errors.company_name ? "is-invalid" : ""}`}
              id="company_name"
              type="text"
              defaultValue={userData?.company_name || ""}
            />
            {errors.company_name && <div className="text-danger mt-1">{errors.company_name}</div>}
          </div>

          {/* Sort Name */}
          <div className="col-md-6">
            <label className="form-label">Sort Name</label>
            <input id="sort_name" className="form-control" type="text" defaultValue={userData?.sort_name || ""} />
          </div>

          {/* Website */}
          <div className="col-md-6">
            <label className="form-label">Website</label>
            <input id="website" className="form-control" type="text" defaultValue={userData?.website || ""} />
          </div>

          {/* Logo */}
          <div className="col-md-6">
            <label className="form-label">Logo</label>
            <input id="logo" className="form-control" type="file" />
            {userData?.logo && <img src={`https://api.mokshiq.in/media/${userData.logo}`} alt="logo" height="40" />}
          </div>

          {/* Status */}
          <div className="col-md-6">
            <label className="form-label">Status</label>
            <select id="status" className="form-select" defaultValue={userData?.status ? "True" : "False"}>
              <option value="True">Active</option>
              <option value="False">Inactive</option>
            </select>
          </div>

          {/* Sender */}
          <div className="col-md-6">
            <label className="form-label">Sender</label>
            <input id="sender_name" className="form-control" type="text" defaultValue={userData?.sender_name || ""} />
          </div>

          {/* SMTP User */}
          <div className="col-md-6">
            <label className="form-label">SMTP User</label>
            <input id="smtp_user" className="form-control" type="text" defaultValue={userData?.smtp_user || ""} />
          </div>

          {/* SMTP Password */}
          <div className="col-md-6">
            <label className="form-label">SMTP Password</label>
            <input id="smtp_password" className="form-control" type="text" defaultValue={userData?.smtp_password || ""} />
          </div>

          {/* SMTP URL */}
          <div className="col-md-6">
            <label className="form-label">SMTP URL</label>
            <input id="smtp_url" className="form-control" type="text" defaultValue={userData?.smtp_url || ""} />
          </div>

          {/* SMTP Port */}
          <div className="col-md-6">
            <label className="form-label">SMTP Port</label>
            <input id="smtp_port" className="form-control" type="text" defaultValue={userData?.smtp_port || ""} />
          </div>

          {/* SMS User */}
          <div className="col-md-6">
            <label className="form-label">SMS User</label>
            <input id="sms_user" className="form-control" type="text" defaultValue={userData?.sms_user || ""} />
          </div>

          {/* SMS Password */}
          <div className="col-md-6">
            <label className="form-label">SMS Password</label>
            <input id="sms_password" className="form-control" type="text" defaultValue={userData?.sms_password || ""} />
          </div>

          {/* SMS UTI */}
          <div className="col-md-6">
            <label className="form-label">SMS UTI</label>
            <input id="sms_uti" className="form-control" type="text" defaultValue={userData?.sms_uti || ""} />
          </div>

          {/* SMS URL */}
          <div className="col-md-6">
            <label className="form-label">SMS URL</label>
            <input id="sms_url" className="form-control" type="text" defaultValue={userData?.sms_url || ""} />
          </div>

          {/* Support Email */}
          <div className="col-md-6">
            <label className="form-label">Support Email</label>
            <input id="support_email" className="form-control" type="email" defaultValue={userData?.support_email || ""} />
          </div>

          {/* Support Phone */}
          <div className="col-md-6">
            <label className="form-label">Support Phone</label>
            <input id="support_phone" className="form-control" type="text" defaultValue={userData?.support_phone || ""} />
          </div>
        </form>
      </div>
    </BaseModal>
  );
}
